import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Badge, Col, FormControl, FormGroup, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import FormDateInterval from "../form/FormDateInterval"
import {Acl, Date, Enums, formatMoney, getPartyIds, Grid, handleResponse} from "../../utils"
import TransactionMassUpdateForm from "./TransactionMassUpdateForm"

const trnStatusOptions = [
	{value: 'PENDING', label: <i className={'fa fa-hourglass'} title={'Ke zpracování'}/>},
	{value: 'PROCESSED', label: <i className={'fa fa-check'} title={'Zpracováno'}/>},
	{value: 'SKIPPED', label: <i className={'fa fa-warning'} title={'Přeskočeno'}/>},
	{value: 'FAILED', label: <i className={'fa fa-times'} title={'Chyba'}/>},
];
const trnTypeOptions = [
	{value: "TRANSFER", label: <i className={'fa fa-exchange'} title={'Převod'}/>},
	{value: "CARD", label: <i className={'fa fa-credit-card'} title={'Karta'}/>},
	{value: "FEE", label: <i className={'fa fa-bank'} title={'Poplatek'}/>},
	// {value: "DEPOSIT", label: <i className={'fa fa-money'} title={'Vklad'}/>},
	{value: "CASH", label: <i className={'fa fa-money'} title={'Hotovost'}/>},
];
const trnDirOptions = [
	{value: 'IN', label: <i className={'fa fa-arrow-down'} title={'Příchozí'}/>},
	{value: 'OUT', label: <i className={'fa fa-arrow-up'} title={'Odchozí'}/>},
];
const isFileOptions = [
	{value: true, label: <i className={'fa fa-archive'} title={'S výpisem'}/>},
	{value: false, label: 'Bez', title: 'Bez výpisu'},
];
const isInvoiceOptions = [
	{value: true, label: <i className={'fa fa-file'} title={'S fakturou'}/>},
	{value: false, label: 'Bez', title: 'Bez faktury'},
];

class Transactions extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.formatStatus = this.formatStatus.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this)
	}

	// componentDidUpdate(prevProps) {
	// 	if (!this.state.action && this.props.items) {
	// 		this.setState({action: {value: 'partyToId'}, actionItems: [8921, 8907], actionModalOpen: true})
	// 	}
	// }

	getDefaultFilter() {
		return {
			"partyIds": getPartyIds(this.props.session.user.parties),
			"trnDir": null,
			"trnType": null,
			"isFile": null,
			"isInvoice": null,
			"search": "",
			"orderCol": "effDate",
			"orderDir": "desc",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({trnId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, trnId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== trnId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items, session} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				if (!Acl.isAllowed(session, Acl.transaction.CREATE) && items[i].trnId) {
					continue
				}
				actionItems.push(items[i].trnId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		if ("archive" === action.value) {
			this.props.onShowModal(
				'Hromadné ukončení činnosti',
				'Skutečně hromadně ukončit činnost vybraných členů (' + actionItems.length + ')?',
				{style: 'danger', label: 'Hromadně ukončit činnost', icon: 'trash'},
				() => this.props.onUpdateTransactionStatus("deleted", actionItems).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.onFilterChange()
					} else {
						return new Promise((resolve, reject) => reject())
					}
				})
			)

		} else {
			this.setState({actionModalOpen: true})
		}
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {action, actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].trnId) >= 0) {
					selected.push(items[i])
				}
			}
		}

		const modal = {
			onHide: this.handleActionModalDismiss,
			onSuccess: () => {
				this.handleActionModalDismiss();
				this.onFilterChange();
			}
		};

		if ("partyToId" === action.value || "partyFromId" === action.value) {
			const template = {};
			if ("partyToId" === action.value) {
				template.partyToId = selected[0].partyToId;
				template.accountToId = selected[0].accountToId;
			} else {
				template.partyFromId = selected[0].partyFromId;
				template.accountFromId = selected[0].accountFromId;
			}
			return <TransactionMassUpdateForm initialValues={{template, items: selected}}
				onMassUpdateTransaction={this.props.onMassUpdateTransaction}
				modal={modal} enums={this.props.enums} what={"partyToId" === action.value ? 'To' : 'From'}/>
		}
	}

	handleSelectChange(name, value, submit = false) {
		const {filter} = this.state;
		filter[name] = value;
		this.setState({filter: filter}, () => {
			this.onFilterChange()
		})
	}

	formatParty(partyId, item, what) {
		const {enums} = this.props;
		const p = Enums.getEnumById(enums, 'parties', partyId);
		const pa = item ? Enums.getEnumById(enums, 'partyAccounts', item['account' + what + 'Id']) : null;
		return <span>
			<Link to={{pathname: 'parties/' + partyId}} title={p.title}>{p.abbr}</Link>
			{pa ? <small> {pa.title}</small> : null}
		</span>
	}

	formatTrnType(cell, row) {
		let ico = "question";
		let variant;
		if (row.trnDir === 'OUT') {
			variant = "secondary";
		} else {
			variant = "success";
		}
		switch (cell) {
			case "TRANSFER":
				if (row.trnDir === 'OUT') {
					ico = "arrow-up";
				} else {
					ico = "arrow-down";
				}
				break;

			case "CARD":
				ico = "credit-card";
				break;

			case "FEE":
			case "DEPOSIT":
			case "CASH":
				ico = "money";
				break;
			default:
		}

		return <Badge variant={variant} title={cell}><i className={"text-light fa fa-" + ico}/></Badge>
	}

	formatSymbols(cell, row) {
		const s = [];
		if (cell) {
			s.push(cell);
		}
		if (row['constSym']) {
			s.push(row['constSym']);
		}
		if (row['specSym']) {
			s.push(row['specSym']);
		}
		return s.length ? s.join(' / ') : null
	}

	formatDescription(cell, row) {
		return <span title={cell}>{cell}</span>;
	}

	formatStatus(cell, trn) {
		let ico = "question";
		let variant = "danger";
		let link = null;
		switch (cell) {
			case "PROCESSED":
				ico = "check";
				if (trn.invoiceId) {
					link = (b) => <Link to={{pathname: 'invoices/' + trn.invoiceId}}>{b}</Link>;
					variant = "success";
				} else {
					variant = "info";
				}
				break;

			case "PENDING":
				ico = "plus";
				variant = "warning";
				link = (b) => <span style={{cursor: "pointer"}} onClick={() => this.props.onShowModal(
					<span>Založení faktury {this.formatParty(trn.partyFromId)} -> {this.formatParty(trn.partyToId)}</span>,
					<div>
						Skutečně založit fakturu z transakce {Date.formatDate(trn.trnDate)} na {formatMoney(trn.trnAmount)}:
						<pre>{trn.description}</pre>
					</div>,
					{style: 'success', label: 'Založit fakturu', icon: 'plus'},
					() => this.props.onCreateInvoiceFromTrn(trn.trnId).then((json) => handleResponse(json, this.props.onFilterChange()))
				)}>{b}</span>;
				break;

			case "SKIPPED":
				ico = "warning";
				variant = "warning";
				link = null;
				break;
			default:
		}
		const b = <Badge variant={variant}><span className={"fa fa-" + ico}/></Badge>;
		if (link) {
			return link(b)
		}
		return b
	}

	formatLink(cell, row) {
		return <Link to={{pathname: "/transactions/" + cell}}>{cell}</Link>
	}

	formatRow(row, index) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;
		const {enums} = this.props;

		return [
			<Row key="1">
				<Col xs={5}>
					{Grid.renderSelect("partyIds", null, filter.partyIds, Enums.createEnumItems(enums, "parties", true, true), this.handleSelectChange, true, true)}
				</Col>
				<Col xs={2}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="VS, popis, ..." onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={2}>
					<FormButtons currentValue={filter.trnType} options={trnTypeOptions} name="trnType" onInputChange={this.handleInputChange}/>
				</Col>
				<Col xs={3}>
					<Row>
						<Col xs={{offset: 1, span: 5}}>
							<FormButtons currentValue={filter.isFile} options={isFileOptions} name="isFile" onInputChange={this.handleInputChange}/>
						</Col>
						<Col xs={6} className={"text-right"}>
							<FormButtons currentValue={filter.isInvoice} options={isInvoiceOptions} name="isInvoice" onInputChange={this.handleInputChange}/>
						</Col>
					</Row>
				</Col>
			</Row>,
			<Row key="2">
				<Col xs={5}>
					<FormDateInterval label={"Datum"} values={filter} name="effDate" onInputChange={this.handleInputChange}/>
				</Col>
				<Col xs={2}>
				</Col>
				<Col xs={2}>
					<FormButtons currentValue={filter.statuses} options={trnStatusOptions} name="statuses" onInputChange={this.handleInputChange}/>
				</Col>
				<Col xs={3}>
					<Row>
						<Col xs={{offset: 1, span: 5}}>
							<FormButtons currentValue={filter.trnDir} options={trnDirOptions} name="trnDir" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 6, null /*() => {
							return '/rest-service/transaction/export/?' + qs.stringify(filter)
						}*/)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="trnId" dataField="trnId" width='4%' dataAlign="center" dataSort={true} dataFormat={this.formatLink}>#</TableHeaderColumn>,
			<TableHeaderColumn key="effDate" dataField="effDate" width='6%' dataAlign="center" dataSort={true} dataFormat={Date.formatDate}>Datum</TableHeaderColumn>,
			<TableHeaderColumn key="trnType" dataField="trnType" width='3%' dataAlign="center" dataSort={true} dataFormat={this.formatTrnType}>Typ</TableHeaderColumn>,
			<TableHeaderColumn key="partyFromId" dataField="partyFromId" width='12%' dataSort={true} dataFormat={(v, row) => this.formatParty(v, row, 'From')}>Odesílatel</TableHeaderColumn>,
			<TableHeaderColumn key="partyToId" dataField="partyToId" width='12%' dataSort={true} dataFormat={(v, row) => this.formatParty(v, row, 'To')}>Příjemce</TableHeaderColumn>,
			<TableHeaderColumn key="description" dataField="description" width='25%' dataSort={true} dataFormat={this.formatDescription}>Popis</TableHeaderColumn>,
			<TableHeaderColumn key="varSym" dataField="varSym" width='10%' dataSort={true} dataFormat={this.formatSymbols}>VS / SS / KS</TableHeaderColumn>,
			<TableHeaderColumn key="trnAmount" dataField="trnAmount" width='7%' dataAlign="right" dataSort={true} dataFormat={(v) => formatMoney(v, 2, 2)}>Částka</TableHeaderColumn>,
			<TableHeaderColumn key="status" dataField="status" width='3%' dataAlign="center" dataFormat={this.formatStatus}><span title={"Stav"}/></TableHeaderColumn>
		];
	}

	render() {
		const {isFetchingItems, items, count, filter, session} = this.props;

		const actions = [];
		actions.push({
			value: "partyFromId",
			label: 'Změnit odesílatele'
		});
		actions.push({
			value: "partyToId",
			label: 'Změnit příjemce'
		});

		const actionCtx = actions.length > 0 ? {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'trnId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		} : null;

		if (items && !Acl.isAllowed(session, Acl.transaction.CREATE)) {
			for (let i = 0; i < items.length; i++) {
				if (items[i].trnId) {
					actionCtx.selectRowProp.unselectable.push(items[i].trnId)
				}
			}
		}

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Transactions.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onMassUpdateTransaction: PropTypes.func.isRequired,
	onCreateInvoiceFromTrn: PropTypes.func.isRequired,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Transactions)
